// const gsap = typeof window === 'object' ? require('gsap').gsap : undefined;
import gsap from 'gsap/all'

const Loader = {
	init: () => {
		var globalMain = document.querySelectorAll('.global-main');

		if (globalMain.length > 0) {
			const mode = JSON.parse(sessionStorage.getItem('pageLoaded')) ? 'default' : 'initial'

			const error = document.querySelector('.error-wrap');

			if (mode === 'initial') {

				gsap.fromTo('.loader__inner', {
					y: '100%',
				}, {
					duration: 0,
					delay: 0,
					ease: 'power4.inOut',
					y: '-40%',
					onComplete: () => {
						// document.querySelector('.loader').remove()
						sessionStorage.setItem('pageLoaded', '1')
						document.querySelector('.global-main').classList.add('loaded');
						document.querySelector('body').classList.remove('loading')
					},
				})

				gsap.fromTo('.global-header', {
					y: '-100%',
				}, {
					duration: 2,
					delay: 0,
					ease: 'power4.inOut',
					y: '0%',
				})

				if (!error) {
					gsap.fromTo('.global-main', {
						opacity: '0',
						y: '100px',
					}, {
						duration: 2,
						delay: 0,
						ease: 'power4.inOut',
						opacity: '1',
						y: '0',
					})
				}

			}
			else {
				document.querySelector('body').classList.remove('loading')
			}
		}
	},
	// setAnimation: (mode) => {
	// 	if (mode === 'initial') {
	// 		gsap.fromTo('.loader-inner', {
	// 			y: '100%',
	// 		}, {
	// 			duration: 1,
	// 			delay: 1,
	// 			ease: 'power4.inOut',
	// 			y: '0%',
	// 			onComplete: () => {
	// 				document.querySelector('.loader').remove()
	// 				sessionStorage.setItem('pageLoaded', '1')
	// 				document.querySelector('.global-main').classList.add('loaded');
	// 				document.querySelector('body').classList.remove('loading')
	// 			},
	// 		})

	// 		gsap.fromTo('.global-header', {
	// 			y: '-100%',
	// 		}, {
	// 			duration: 2,
	// 			delay: 1.3,
	// 			ease: 'power4.inOut',
	// 			y: '0%',
	// 		})

	// 		gsap.fromTo('.global-main', {
	// 			opacity: '0',
	// 			y: '100px',
	// 		}, {
	// 			duration: 2,
	// 			delay: 1.3,
	// 			ease: 'power4.inOut',
	// 			opacity: '1',
	// 			y: '0',
	// 		})

	// 	}
	// 	else {
	// 		document.querySelector('body').classList.remove('loading')
	// 	}
	// }
}

export default Loader
